// extracted by mini-css-extract-plugin
export var postGrid = "t_bh";
export var wpPageLayout = "t_bg";
export var wpPageRelatedGrid = "t_bj";
export var wpPageRoot = "t_bf";